 


 // Ibs
//  export const variables={

//   API_URL:"https://menafn.com/mgmt_react/API/api" 

 
//  ,ImageStart: "https://menafn.com/updates/pr/"
       
//             ,basename: '' 
//             ,basename_url: 'https://menafn.com/' 
//             ,domain_name: 'http://menafn.com'
//             ,domain: 'Menafn'
          
//   }


  

  
// Main LocalHost   
// export const variables={


//   API_URL:"http://localhost:6605/api" 
  

// ,ImageStart: "https://menafn.com/updates/"
     
//              ,basename: '' 
//             ,basename_url: 'https://menafn.com/' 
//             ,domain_name: 'http://menafn.com'
//             ,domain: 'menafn'         
//   }


  // // News LocalHost   
  // export const variables={


    
    
  //   API_URL:"http://localhost:6605/api" 
  // ,ImageStart: "https://coinsinsight.com/updates/pr/"
       
  //              ,basename: '' 
  //             ,basename_url: 'https://coinsinsight.com/' 
  //             ,domain_name: 'http://coinsinsight.com'
  //             ,domain: 'CoinsInsight'         
  //   }
  
  
   
  
  ////Online   
  export const variables={
  
  
  API_URL:"https://coinsinsight.com/mgmt_react/API/api" 
  ,ImageStart: "https://coinsinsight.com/updates/pr/"
  
                 ,basename: '' 
                 ,basename_url: 'https://coinsinsight.com/' 
                 ,domain_name: 'https://coinsinsight.com'
                 ,domain: 'coinsinsight'
  
                
    }
  
   
    
  